type TemplateUrlConfig = {
  CDN_URL: string;
  RESIZE_URL: string;
  EMBED_URL: string;
  APP_URL: string;
  ENV: string;
};

export const getTemplateFullImageUrl = (hash: string, cdnUrl: string) => `${cdnUrl}/designs/${hash}/images/jpg`;

export const getDesignJson = (hash: string, cdnUrl: string) => `${cdnUrl}/designs/${hash}/json`;

export const getTemplateImageUrl = (hash: string, cdnUrl: string, size = 'large') =>
  `${cdnUrl}/resize/designs/${hash}/${size}`;

export const getTemplateImageRegenerateUrl = (hash: string, resizeUrl: string, size = 'large') =>
  `${resizeUrl}/designs/${hash}/${size}`;

export const getTemplateIFrameUrl = (hash: string, config: Pick<TemplateUrlConfig, 'EMBED_URL' | 'ENV'>) =>
  `${config.EMBED_URL}/?hash=${hash}&env=${config.ENV === 'live' ? 'live' : 'dev'}`;

export const getTemplateGenerateDesignUrl = (hash: string, appUrl: string) =>
  `${appUrl}/go-to/create-from-design/${hash}`;

export function urlParams(values: Record<string, unknown>): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(values)) {
    if (value) {
      params.set(key, String(value));
    }
  }

  return params.size ? '?' + params.toString() : '';
}
